import * as Yup from 'yup'

const customerCheckoutCartFormSchema = Yup.object().shape({
  customer: Yup.object().shape({
    id: Yup.number().required('Harus pilih Customer.')
  }).required('Required'),

  product: Yup.object().shape({
    id: Yup.number().required('Harus pilih Product.')
  }).required('Required'),

  product_dimension_id: Yup.number().required('Harus pilih Product Dimension.'),

  quantity: Yup.number().positive('Must be more than 0').required('Required')
})

export default customerCheckoutCartFormSchema
